const TEMPLATE = `<md-chart-widget :id='id'
    :widget='widget'
    ref='chart'
    showLegend
     
    data-TODO="!!! remove the below properties!!!"
     
    :type='widget.chartType'
    :options='widget.options'
    :data-source='widget.endPoint' />`

function makeChart(alias, chart) {
  return {
    alias,

    props: { widget: Object, id: String },

    created() {
      this.widget.chartComponent = chart

      this.$on('scrollIntoView', this.load)
    },

    methods: {
      load: function () {
        this.$refs.chart.$emit('scrollIntoView')
      }
    },

    template: TEMPLATE
  }
}

export default makeChart



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/widgets/baseChartWidget.js